import gql from 'graphql-tag';

// Every master, both payer sides, in the order the resolver walks them.
//
// ENDED and NON-RESOLVING masters are included on purpose. A master can be
// open-ended and still not resolve, because the resolver only considers products
// that are active and on this side's current dynamic_properties.defaultMaster
// allowlist - so `endTs` alone does not tell you whether a master is live.
// `resolving` and `liveButNotResolving` are
// computed server-side against the resolver's own predicate, deliberately not
// re-derived here: two implementations of "can this resolve" would drift, and the
// screen would then confidently report the wrong thing.
const defaultCoverageMastersQuery = gql`
  query GetDefaultCoverageMasters {
    defaultCoverageMasters {
      id
      masterType
      productId
      productCode
      productName
      version
      startTs
      endTs
      priceDs
      productActive
      productCategoryCode
      resolving
      liveButNotResolving
      sentinelCustomerNum
      customerGroupName
    }
  }
`;

export default defaultCoverageMastersQuery;
